module.exports = new __parcel__URL__("Product2.81ab19ec.png").toString();